import Translator from "bazinga-translator";

let promise;

switch (Translator.locale) {
    case "en":
        promise = Promise.all([
            import("TapSiteBundle/en.json"),
            import("TapSiteBundle_Pi/en.json"),
            import("TapSiteBundle_Ai/en.json"),
            import("TapTrackingBundle/en.json"),
        ]);

        break;

    case "de":
        promise = Promise.all([import("TapSiteBundle/de.json"), import("TapSiteBundle_Pi/de.json")]);

        break;

    case "fr":
        promise = Promise.all([import("TapSiteBundle/fr.json"), import("TapSiteBundle_Pi/fr.json")]);

        break;

    case "nl":
        promise = Promise.all([import("TapSiteBundle/nl.json"), import("TapSiteBundle_Pi/nl.json")]);

        break;

    case "es":
        promise = Promise.all([import("TapSiteBundle/es.json"), import("TapSiteBundle_Pi/es.json")]);

        break;

    case "pt":
        promise = Promise.all([import("TapSiteBundle/pt.json"), import("TapSiteBundle_Pi/pt.json")]);

        break;
}

// Botched solution, in orderto prevent BC Break
Translator.loadTranslations = promise.then(translations => {
    Translator.defaultDomain = "TapSiteBundle";
    translations.forEach(trans => Translator.fromJSON(trans));

    return Translator;
});

module.exports = Translator;
